import { render, staticRenderFns } from "./CourseCategory.vue?vue&type=template&id=0541a28e&scoped=true&"
import script from "./CourseCategory.vue?vue&type=script&lang=js&"
export * from "./CourseCategory.vue?vue&type=script&lang=js&"
import style0 from "./CourseCategory.vue?vue&type=style&index=0&id=0541a28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0541a28e",
  null
  
)

export default component.exports